// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2uwog","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__31zK0"};